import { Environment, getEnvironment } from "@sr-partner-portal/common";

import type { BaseConfig } from "./base-config";
import { generateDevelopmentConfig } from "./generate-config.development";
import { generateProductionConfig } from "./generate-config.production";
import { generateStagingConfig } from "./generate-config.staging";

let config: BaseConfig;

switch (getEnvironment()) {
    case Environment.DEVELOPMENT:
        config = generateDevelopmentConfig();
        break;
    case Environment.STAGING:
        config = generateStagingConfig();
        break;
    case Environment.PRODUCTION:
        config = generateProductionConfig();
        break;
    default:
        throw new Error(`Invalid environment: ${getEnvironment()}`);
}

export { config };
